var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dialog-info',{ref:"dialog",attrs:{"title":_vm.title,"isLoading":_vm.isLoading}},[_c('stock-card',{attrs:{"data":_vm.data,"model":_vm.StockModel,"hasCreateNew":false,"disabled":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }